import { useEffect, useRef } from "react";

const FOCUSABLE_SELECTOR =
	'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

export default function useModalA11y(isOpen, onClose) {
	const contentRef = useRef(null);

	useEffect(() => {
		if (!isOpen) return;

		const previouslyFocused = document.activeElement;
		const content = contentRef.current;

		const focusable = content
			? content.querySelectorAll(FOCUSABLE_SELECTOR)
			: [];
		(focusable[0] || content)?.focus();

		const handleKeyDown = (event) => {
			if (event.key === "Escape") {
				onClose();
				return;
			}

			if (event.key !== "Tab" || focusable.length === 0) return;

			const first = focusable[0];
			const last = focusable[focusable.length - 1];

			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		};

		document.addEventListener("keydown", handleKeyDown);

		return () => {
			document.removeEventListener("keydown", handleKeyDown);
			previouslyFocused?.focus?.();
		};
	}, [isOpen, onClose]);

	return contentRef;
}
